import type { User } from '@/types/auth';
import { normalizeUser } from '@/utils/agent';

export { normalizeUser };

export function getUserDisplayName(
  user: Pick<User, 'firstName' | 'lastName' | 'email'> | null | undefined,
): string {
  if (!user) return 'Admin';
  const name = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
  return name || user.email || 'Admin';
}

const ROLE_LABELS: Record<string, string> = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  manager: 'Manager',
  customer: 'Customer',
};

export function getUserRoleLabel(role?: string | null): string {
  if (!role) return 'Admin';
  return ROLE_LABELS[role] ?? role.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function getStaffRoleLabel(
  user: { role?: string | null; accessProfileId?: string | null },
  profiles: Array<{ id: string; name: string }> = [],
): string {
  if (user.role === 'super_admin') return 'Super Admin';
  if (user.accessProfileId) {
    const profile = profiles.find((item) => item.id === user.accessProfileId);
    if (profile) return profile.name;
  }
  return getUserRoleLabel(user.role);
}
